module.exports = __webpack_public_path__ + "static/media/nar-2.5122a97a.jpg";